export { default as ArrowLeftOutlineIcon } from './ArrowLeftOutlineIcon';
